module.exports = __webpack_public_path__ + "static/media/dev-logo.2bbd6599.svg";